import { Dispatch } from 'redux';

import { Events } from '../constants/webSocketConsts/events';
import { Price, productsApi } from '../services/api/productsApi';
import { ensureUnreachable } from '../utils/common_utils';

const updateCache = (event: Events, items: Price[], draft?: Price[]) => {
  console.info('updateCache', { draft, event, items });
  const [priceObj] = items;

  if (!draft) {
    return;
  }

  const upcomingPriceIndex = draft.findIndex(
    (item: Price) => item.id === priceObj.id,
  );

  switch (event) {
    case Events.Insert: {
      if (upcomingPriceIndex !== -1) {
        return;
      }

      draft.unshift(priceObj);
      break;
    }
    case Events.Modify:
      if (upcomingPriceIndex === -1) {
        return;
      }
      draft.splice(
        0,
        draft.length,
        ...draft.map((item: Price) =>
          item.id === priceObj.id ? priceObj : item,
        ),
      );
      break;
    case Events.Remove:
      if (upcomingPriceIndex === -1) {
        return;
      }
      draft.splice(upcomingPriceIndex, 1);
      break;
    case Events.Refresh:
    case Events.DomainVerified:
      return;
    default:
      ensureUnreachable(event);
  }
};

export function handlePriceUpdate(
  event: Events,
  items: Price[],
  dispatch: Dispatch<any>,
) {
  // for price showing on price detail
  const priceObj = items.at(0);
  if (!priceObj) {
    console.warn('price not found');
    return;
  }
  // for prices on price detail page
  dispatch(
    productsApi.util.updateQueryData(
      'getPricesByProductId',
      priceObj.productId,
      (draft?: Price[]) => {
        updateCache(event, items, draft);
      },
    ),
  );
  // for prices on portal price list page
  dispatch(
    productsApi.util.updateQueryData(
      'getPricesByPortal',
      undefined,
      (draft?: Price[]) => {
        updateCache(event, items, draft);
      },
    ),
  );
}
